import { useEffect } from "react";
import {setFocusOnlyOnActiveSlides} from "../utils";

const useSetInitialFocusOnlyOnActiveSlides = (): void => {
    useEffect(() => {
        setFocusOnlyOnActiveSlides();
      }, [])
}

export default useSetInitialFocusOnlyOnActiveSlides;
